import { create } from "zustand";

type SessionState = {
  username: string;
  authenticated: boolean;
  remember: boolean;
  login: (username: string, remember: boolean) => void;
  logout: () => void;
  hydrate: (username: string, authenticated: boolean, remember: boolean) => void;
};

export const useSessionStore = create<SessionState>((set) => ({
  username: "",
  authenticated: false,
  remember: false,
  login: (username, remember) => set({ username, authenticated: true, remember }),
  logout: () => set({ username: "", authenticated: false, remember: false }),
  hydrate: (username, authenticated, remember) => set({ username, authenticated, remember }),
}));
